import React from 'react';
import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
} from '../../components/ui/card';
import { getSuccessRateColor } from './utils/health-colors';

interface SummaryCardsProps {
  totalJobs: number;
  successRate: number;
  totalFailures: number;
  activeInvocations?: number;
}

export const SummaryCards: React.FC<SummaryCardsProps> = ({
  totalJobs,
  successRate,
  totalFailures,
  activeInvocations,
}) => {
  const showActive = activeInvocations !== undefined;

  return (
    <div
      className={`grid grid-cols-2 ${
        showActive ? 'md:grid-cols-4' : 'md:grid-cols-3'
      } gap-4`}
    >
      <Card>
        <CardHeader className="pb-2">
          <CardTitle className="text-sm font-medium text-muted-foreground">
            Total Jobs
          </CardTitle>
        </CardHeader>
        <CardContent>
          <p className="text-2xl font-bold">{totalJobs.toLocaleString()}</p>
        </CardContent>
      </Card>

      <Card>
        <CardHeader className="pb-2">
          <CardTitle className="text-sm font-medium text-muted-foreground">
            Success Rate
          </CardTitle>
        </CardHeader>
        <CardContent>
          <p
            className={`text-2xl font-bold ${getSuccessRateColor(successRate)}`}
          >
            {successRate.toFixed(2)}%
          </p>
        </CardContent>
      </Card>

      <Card>
        <CardHeader className="pb-2">
          <CardTitle className="text-sm font-medium text-muted-foreground">
            Failures
          </CardTitle>
        </CardHeader>
        <CardContent>
          <p
            className={`text-2xl font-bold ${
              totalFailures > 0 ? 'text-red-600' : 'text-green-600'
            }`}
          >
            {totalFailures.toLocaleString()}
          </p>
        </CardContent>
      </Card>

      {showActive && (
        <Card>
          <CardHeader className="pb-2">
            <CardTitle className="text-sm font-medium text-muted-foreground">
              Active Invocations
            </CardTitle>
          </CardHeader>
          <CardContent>
            <p
              className={`text-2xl font-bold ${
                activeInvocations > 0 ? 'text-amber-600' : 'text-gray-600'
              }`}
            >
              {activeInvocations.toLocaleString()}
            </p>
          </CardContent>
        </Card>
      )}
    </div>
  );
};
